import { motion } from "framer-motion";
import { AibaLogo } from "./Logo";
import { scrollToId } from "../../hooks/useLenis";
import { useLang } from "../../i18n/LanguageContext";
import { ShieldCheck } from "lucide-react";

export const Footer = () => {
  const { t, lang } = useLang();
  return (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-blue-500/10 pt-24 pb-12">
    <div className="grid-lines absolute inset-0 opacity-40" />
    <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="flex flex-wrap items-center justify-center gap-3 rounded-full border border-blue-400/30 bg-blue-400/5 px-6 py-3 text-center glow-cyan"
        style={{ width: "fit-content", margin: "0 auto" }}
        data-testid="footer-security-badge"
      >
        <ShieldCheck size={16} className="text-blue-400" />
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-blue-100">
          Sécurisé par protocole de paiement chiffré
        </span>
      </motion.div>

      <div className="mt-16 flex flex-col items-center justify-between gap-10 lg:flex-row lg:items-end">
        <div>
          <div className="flex items-center gap-3">
            <AibaLogo size={34} />
            <span className="font-display text-2xl font-800 tracking-tighter text-white">AIBA</span>
          </div>
          <p className="mt-4 max-w-sm font-body text-sm leading-relaxed text-[#8AA0C0]">
            AIBA est une entité enregistrée dédiée à l'excellence technologique. Nous transformons la
            complexité en puissance actionnable.
          </p>
        </div>
        <nav className="flex flex-wrap gap-x-8 gap-y-3">
          {[
            { label: "Modules", id: "marketplace" },
            { label: "Vision", id: "vision" },
            { label: "Contact", id: "contact" },
          ].map((l) => (
            <button
              key={l.id}
              data-testid={`footer-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="font-mono text-xs uppercase tracking-[0.2em] text-[#8AA0C0] transition-colors hover:text-blue-300"
            >
              {l.label}
            </button>
          ))}
        </nav>
      </div>

      <div className="pointer-events-none mt-20 select-none overflow-hidden">
        <span className="block font-display text-[24vw] font-900 leading-[0.75] tracking-tighter text-white/[0.03] lg:text-[18vw]">
          AIBA
        </span>
      </div>

      <div className="mt-8 flex flex-col items-center justify-between gap-4 border-t border-blue-500/10 pt-8 sm:flex-row">
        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#405060]">
          © {new Date().getFullYear()} AIBA · {t("footer.tagline")}
        </span>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          <a href="/legal" data-testid="footer-legal-link" className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#405060] transition-colors hover:text-blue-300">
            {t("footer.legal")}
          </a>
          <a href="/confidentialite" data-testid="footer-privacy-link" className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#405060] transition-colors hover:text-blue-300">
            {lang === "fr" ? "Confidentialité" : "Privacy"}
          </a>
          <a href="/cookies" data-testid="footer-cookies-link" className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#405060] transition-colors hover:text-blue-300">
            Cookies
          </a>
          <button data-testid="footer-manage-cookies" onClick={() => window.dispatchEvent(new Event("aiba:cookie-prefs"))} className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#405060] transition-colors hover:text-blue-300">
            {lang === "fr" ? "Gérer les cookies" : "Manage cookies"}
          </button>
        </div>
        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#405060]">
          {t("footer.stripe")}
        </span>
      </div>
    </div>
  </footer>
  );
};
